module.exports = __webpack_public_path__ + "img/default.30f39a0b.png";